import './styles.sass';

import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import * as QueryFetcher from 'components/Explorer/models/query_fetcher';
import FilterSet from 'components/Explorer/models/filter_set';
import HelpLink from './HelpLink';
import useQueryParams from 'hooks/useQueryParams';

const DimensionsSearchFilter = ({ filterSet }) => {
  const params = useQueryParams();

  const searchID = filterSet.get('dimensions_search_id');

  const [loading, setLoading] = useState(Boolean(searchID));
  const [dimensionsSearch, setDimensionsSearch] = useState(null);

  useEffect(() => {
    if (!searchID) {
      setDimensionsSearch(null);
      setLoading(false);
      return undefined;
    }

    setLoading(true);
    const request = QueryFetcher.fetchJSON('filters/dimensions_search', params);

    request.then((err, response) => {
      if (err?.name === 'AbortError') return;

      if (!err && response.body) {
        setDimensionsSearch(response.body);
      }
      setLoading(false);
    });

    return () => request.abort();
  }, [searchID]);

  const onClickSet = () => {
    window.open(window.site_config.dimensionsBaseURL, '_blank');
  };

  const onClickClear = () => {
    filterSet.clear('dimensions_search_id');
    setDimensionsSearch(null);
  };

  return (
    <div className="Explorer-AdvancedSearch-field-container DimensionsSearchFilter">
      <span>
        &nbsp;
        <HelpLink
          href={I18n.t('Explorer.AdvancedSearch.fields.dimensions_search.help_uri')}
          tip={I18n.t('Explorer.AdvancedSearch.fields.dimensions_search.description')}
          analyticsFieldName="Dimensions Integration"
        />
      </span>
      <fieldset>
        {loading ? (
          <div className="DimensionsSearchFilter-loading-message">
            {I18n.t('Explorer.AdvancedSearch.fields.dimensions_search.loading')}
          </div>
        ) : dimensionsSearch ? (
          <div className="DimensionsSearchFilter-content">
            <header>
              <img className="integrations-logo" src="/explorer/dimensions-logo.svg" alt="Dimensions" />
            </header>
            <div className="Explorer-AdvancedSearch-field-container-content-main" data-text-id="query_info">
              {I18n.htmlSafe('Explorer.AdvancedSearch.fields.dimensions_search.query_info_html', {
                query_title: dimensionsSearch.description
              })}
            </div>
            <div className="Explorer-AdvancedSearch-field-container-buttons">
              <button type="button" className="generic-button" onClick={onClickSet} data-btn-id="edit">
                {I18n.t('Explorer.AdvancedSearch.fields.dimensions_search.edit')}
              </button>
              <button type="button" className="generic-button" onClick={onClickClear} data-btn-id="clear">
                {I18n.t('Explorer.AdvancedSearch.fields.dimensions_search.clear')}
              </button>
            </div>
          </div>
        ) : (
          <div className="DimensionsSearchFilter-content">
            <header>
              <img className="integrations-logo" src="/explorer/dimensions-logo.svg" alt="Dimensions" />
            </header>
            <div className="Explorer-AdvancedSearch-field-container-content-main" data-text-id="no_query">
              {I18n.htmlSafe('Explorer.AdvancedSearch.fields.dimensions_search.no_query_html')}
            </div>
          </div>
        )}
      </fieldset>
    </div>
  );
};

DimensionsSearchFilter.propTypes = {
  filterSet: PropTypes.instanceOf(FilterSet).isRequired
};

export default DimensionsSearchFilter;
